import { Component, Input } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { showMatSnackMessage } from 'src/app/core/utils/message-handler.util';
import { conceptosDto } from 'src/app/models/carga-fc.dto';
import { CentrosCostoDto } from 'src/app/models/centros-costo.dto';
import { CentrosCostoService } from 'src/app/services/centros-costo.service';
import { ModalCentrosCostoComponent } from 'src/app/shared/modal-centros-costo/modal-centros-costo.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-listados-conceptos-proveedor',
  templateUrl: './listados-conceptos-proveedor.component.html',
  styleUrl: './listados-conceptos-proveedor.component.scss'
})
export class ListadosConceptosProveedorComponent {

  @Input() conceptos!: conceptosDto[] | null;
  monedaTotal: string = '$';
  centrosCosto: CentrosCostoDto[] = [];

  constructor(private snackBar: MatSnackBar,
    private centrosCostoService: CentrosCostoService,
    private dialog: MatDialog
  ) { }


  ngOnInit(): void {
    this.centrosCostoService.getAll().subscribe(data => this.centrosCosto = data);
  }

  ngAfterViewInit() {
    this.procesarInput();
  }

  get tieneConceptos(): boolean {
    return !!this.conceptos?.length;
  }

  procesarInput(): void {
    if (this.conceptos
      && this.conceptos.length > 0) {

      let mone = this.conceptos[0].MONE;

      if (mone == 'PES') {
        this.monedaTotal = '$';
      } else {
        this.monedaTotal = mone;
      }
      
    }
  }

  obtenerTotalSinIvas(): number {

    if (!this.conceptos) return 0;

    let totalSinIvas = this.conceptos
      .reduce((sum, order) => sum + (order.impor_editable || 0), 0);

    return totalSinIvas || 0;
  }

  obtenerTotalConIvas(): number {
    if (!this.conceptos) return 0;

    const totalConIvas = this.conceptos.reduce((sum, c) => {
      const importe = c.impor_editable ?? 0;
      const iva = c.porcen_iva_editable ?? 0;

      // Si IVA es 0, se suma solo el importe
      // Si IVA > 0, se suma importe con IVA
      const total = iva > 0 ? importe * (1 + iva / 100) : importe;

      return sum + total;
    }, 0);

    return totalConIvas || 0;
  }

  abrirModalObservaciones(c: any) {
    Swal.fire({
      title: 'Editar Observación',
      input: 'textarea',
      inputLabel: 'Ingrese observación',
      inputValue: c.observaciones || '',
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      cancelButtonText: 'Cancelar',
      inputAttributes: {
        maxlength: '200',
        autocapitalize: 'off',
        autocorrect: 'off'
      }, 
      customClass: {
        popup: 'rounded-xl'
      }
    }).then((result) => {
      if (result.isConfirmed && result.value !== undefined) {
        c.observaciones = result.value;

        // Mostrar confirmación
        Swal.fire({
          icon: 'success',
          title: 'Observación actualizada',
          timer: 1500,
          showConfirmButton: false
        });
      }
    });
  }

  // Obtiene una clave única para la orden
  getOrderKey(order: conceptosDto): string {
    return `${order.TIPO}-${order.NUM}-${order.renglon}`;
  }

  validarImporte(c: conceptosDto): void {
    const max = c.impor_pend ?? 0;
    const actual = c.impor_editable ?? 0;

    if (actual < 0) {
      c.impor_editable = 0;
    } else if (actual > max) {
      c.impor_editable = max;
      let mensajeValidacion = `Importe excedido para ${c.descrip_concep}. Máximo permitido: ${this.monedaTotal} ${max}`;
      showMatSnackMessage(this.snackBar, mensajeValidacion, 5000, 'snackbar-custom-orange');
    }
  }

  validarIva(c: conceptosDto): void {
    const actual = c.porcen_iva_editable ?? 0;

    if (actual < 0) {
      c.porcen_iva_editable = 0;
    }
  }

  seleccionarCenco(cenco: conceptosDto) {
    const dialogConfig: MatDialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = ['slide-dialog', 'dialog-responsive-60'];
    dialogConfig.width = '600px';
    dialogConfig.data = this.centrosCosto;

    const dialogRef = this.dialog.open(ModalCentrosCostoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result.response) {
        cenco.CODI_CENCO = result.response.codi_cenco ?? '';
        cenco.descrip_cenco = result.response.descrip_cenco ?? '';
      }
    });
  }

  eliminarCenco(c: any) {
    c.CODI_CENCO = null;
    c.descrip_cenco = null;
  }
}
